enum ScienceFamiliarity {
  Very = 'Very',
  Somewhat = 'Somewhat',
  Attempted = 'Attempted',
  NotAtAll = 'Not at all',
}

const scienceQuestion = {
  name: 'science',
  title: 'How familiar are you with fitness/nutrition science?',
  description: 'This helps us understand where you’re starting from.',
  type: 'radiogroup',
  choices: [
    {
      value: ScienceFamiliarity.Very,
      text: "<div class='icon-button'><div>🧠</div><div>Evidence-based Expert<br /><span class=\"small-text\">I actively follow research and understand how to apply it</span></div></div>",
    },
    {
      value: ScienceFamiliarity.Somewhat,
      text: "<div class='icon-button'><div>📚</div><div>Overwhelmed Enthusiast<br /><span class=\"small-text\">I know a fair bit, but struggle to turn it into a plan</span></div></div>",
    },
    {
      value: ScienceFamiliarity.Attempted,
      text: "<div class='icon-button'><div>🔍</div><div>Skeptical Scroller<br /><span class=\"small-text\">I read online advice, but don’t know what to trust</span></div></div>",
    },
    {
      value: ScienceFamiliarity.NotAtAll,
      text: "<div class='icon-button'><div>🤷</div><div>Bro Science Survivor<br /><span class=\"small-text\">I’ve tried it all, but I’m ready for actual science</span></div></div>",
    },
  ],
  isRequired: true,
};

export {
  ScienceFamiliarity,
  scienceQuestion,
};